// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__20YH3","colCheckbox":"styles_colCheckbox__2pBK6"};